import { useState } from "react";

import type { ExportConnectionInput } from "app/mutations/__generated__/ExportConnectionMutation.graphql";
import type { FilterElementInput } from "app/utils/filters";

/**
 * CSV export state for a filtered connection. `getFilter` is read on click, not
 * on render: a `params` change mid-export restarts it.
 */
export function useFilteredCsvExport(
  getFilter: () => FilterElementInput | undefined,
) {
  const [exportInProgress, setExportInProgress] = useState(false);
  const [exportParams, setExportParams] =
    useState<ExportConnectionInput["params"]>(undefined);

  const handleExport = () => {
    const filter = getFilter();
    setExportParams(
      filter
        ? [
            {
              name: "filterElement",
              type: "FilterElementInput",
              valueJSON: JSON.stringify(filter),
            },
          ]
        : undefined,
    );
    setExportInProgress(true);
  };

  return {
    exportInProgress,
    exportParams,
    handleExport,
    markComplete: () => setExportInProgress(false),
  };
}
